import _ from 'lodash'

import { CreateStaffDto } from '@/core/models/staff.model'
import { SubscriptionType } from './subscription/types'
import { KeycloakUserType } from '@/core/types/shared'

type oldCreatestaffDto = {
  name: string
  surname: string
  cps?: string
  email: string
  status: 'MEDECIN' | 'PDS' | 'INVITE'
  active?: boolean
  stripe?: string
  phone?: string
  subscription?: SubscriptionType
}

export function sanitizeStaffCreation(values: Record<string, any>): CreateStaffDto {
  let data = _.pickBy(values, (value) => !_.isEmpty(value)) as oldCreatestaffDto
  data.cps = data.cps !== '' ? data.cps : undefined
  data.status = 'MEDECIN'
  data.email = data.email ? data.email.toLowerCase() : data.name.concat(data.surname).concat('@no-email.com')
  return {
    cps: data.cps !== '' ? data.cps : undefined,
    status: 'MEDECIN',
    email: data.email,
    userInfo: {
      name: data.name,
      surname: data.surname
    },
    type: KeycloakUserType.STAFF,
    contactInfo: {
      phone: data.phone
    },
  }
}
